// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"252734f7","372":"a497df2d","443":"12d75119","738":"ce3afd69","787":"66f72b2e","856":"3521b75f"}[chunkId] + ".chunk.js";
};